module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.featured), function(row, index) {
    return _c('div', {
      staticClass: "col-xl-4 col-lg-4 col-md-6"
    }, [_c('div', {
      staticClass: "articles-box news-box"
    }, [_c('a', {
      attrs: {
        "href": '/featured/' + row.id
      }
    }, [_c('div', {
      staticClass: "text text-center"
    }, [_c('h5', {
      staticClass: "title text-primary"
    }, [_vm._v(_vm._s(row.title))]), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "featured mb-0",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("頂上故事 (Top Stories)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-524aaa3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Featured.vue
// module id = 163
// module chunks = 1